import React, { useMemo } from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { trackOpenProject } from '../../../analytics';

import { ButtonLink } from '../../../components/general';

import { URL } from '../../../constants';
import { Event } from '../../../types';
import { getEventImg, getUrl } from '../../../utils';

import ProjectBlockOverlay from './projectBlockOverlay';

interface Props {
  event: Event;
}

const ProjectBlock: React.FC<Props> = (props) => {
  const { event } = props;

  const navigate = useNavigate();

  const vbLink = getUrl(URL.VIDEO_BUILDER, event.eventId);

  const onClickEvent = (isLink?: boolean) => {
    const pathname = window.location.pathname.replaceAll('/', '');
    trackOpenProject(pathname || 'home', event);

    if (!isLink) navigate(vbLink);
  };

  const thumbnailImg = useMemo(() => {
    if (event.banner) return getEventImg('thumbnail', event.banner);

    const numOfFiles = 20;
    const num = Math.ceil(
      new Date(event.created).getMilliseconds() / (1000 / numOfFiles),
    );

    return require(
      `/src/assets/projects-thumbnails/templify_fluid_dream_images_${num}.png`,
    );
  }, [event]);

  return (
    <ButtonLink
      to={vbLink}
      onClick={() => onClickEvent(true)}
      variant="custom"
      colour="custom"
      className="w-[var(--project-block-width)]"
    >
      <div className="flex relative w-full aspect-video mb-1 sm:mb-2 rounded-md overflow-hidden">
        <img
          className="w-full h-full object-cover"
          src={thumbnailImg}
          alt="Project Thumbnail"
        />

        <ProjectBlockOverlay event={event} onClickEvent={onClickEvent} />
      </div>

      <div className="text-xs sm:text-sm font-bold text-black hover:text-primary-900">
        {event.name}
      </div>

      <div className="flex justify-between flex-wrap gap-x-2 text-xs text-black opacity-50">
        <div className="capitalize">{event.videoMode}</div>
        <div>{moment(event.modified).fromNow()}</div>
      </div>
    </ButtonLink>
  );
};

export default ProjectBlock;
